export const COLORS = {
  primary: "#4f46e5",
  primaryLight: "#eef2ff",
  secondary: "#14b8a6",

  bgMain: "#f6f8fb",
  cardBg: "#ffffff",

  textPrimary: "#111827",
  textSecondary: "#6b7280",

  border: "#e5e7eb",

  sidebarBg: "#ffffff",
  sidebarActive: "#eef2ff",

  shadow: "0 8px 20px rgba(0,0,0,0.06)",
};